
export type QuotesType = 'M' | 'D';

export enum QUOTES_TYPE {
    MARKED = 'M',
    UNMARKED = 'D',
}